import { configureStore } from "@reduxjs/toolkit";

/**
 * DataAttributesReducer - Returns empty data attributes object.
 * This is required for RichText component which uses useSelector to access state.dataAttributes.
 */
function DataAttributesReducer(state = {}) {
  return state;
}

/**
 * Store - Redux store for scrollable app.
 * Minimal configuration with dataAttributes reducer required by RichText component.
 */
export const Store = configureStore({
  reducer: {
    dataAttributes: DataAttributesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
    }),
});
